import * as React from "react";
import { AgentCreateForm } from "./form";

export const AgentCreateInitializer: React.FC = () => {
  return <AgentCreateForm />;
};
